import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/relatorios`;

export const gerarRelatorioHtml = async (listaDados) => {
  return await axios.post(`${httpUrl}/html-relatorio`, listaDados).then((response) => response);
};

export const gerarRelatorioPdf = async (listaDados) => {
  return await axios
    .post(`${httpUrl}/gerar-relatorio-pdf`, listaDados, {
      responseType: 'blob',
    })
    .then((response) => response);
};

export const gerarRelatorioPdfAtendimentoAgrupadoMesAno = async (listaDados) => {
  return await axios
    .post(`${httpUrl}/gerar-relatorio-pdf-atendimento-agrupado-por-mes-ano`, listaDados, {
      responseType: 'blob',
    })
    .then((response) => response);
};

export const gerarRelatorioProfissionais = async (listaDados) => {
  return await axios
    .post(`${httpUrl}/relatorio-profissionais`, listaDados, {
      responseType: 'blob',
    })
    .then((response) => response);
};

export const gerarRelatorioHtmlProfissionais = async (listaDados) => {
  return await axios.post(`${httpUrl}/html-relatorio-profissionais`, listaDados).then((response) => response);
};

export const gerarRelatorioPacientes = async (listaDados) => {
  return await axios
    .post(`${httpUrl}/relatorio-pacientes`, listaDados, {
      responseType: 'blob',
    })
    .then((response) => response);
};

export const gerarRelatorioHtmlPaciente = async (listaDados) => {
  return await axios.post(`${httpUrl}/html-relatorio-pacientes`, listaDados).then((response) => response);
};
